import { BiSave, BiTrash } from "react-icons/bi";
import { FeatureCollection } from "./mapMessages";
import ModuleButton from "../../button/ModuleButton";
import FadeAnimation from "../../animations/FadeAnimation";

interface MapButtonsProps {
  projectMapData: any;
  areaToSave: FeatureCollection | null;
  onClearArea: () => void;
  onSaveArea: () => void;
  isSaveLoading: boolean;
}

const MapButtons = ({
  projectMapData,
  areaToSave,
  onClearArea,
  onSaveArea,
  isSaveLoading
}: MapButtonsProps) => {
  return (
    <div className="w-100 d-flex align-items-center mt-2 gap-8">
      <FadeAnimation isShown={!!projectMapData}>
        <ModuleButton
          labelKey="map.delete_project_area"
          icon={BiTrash}
          buttonType="button"
          handleClick={onClearArea}
          styleType="error"
          isLoading={isSaveLoading}
        />
      </FadeAnimation>
      <FadeAnimation isShown={!!areaToSave}>
        <ModuleButton
          labelKey={projectMapData ? "map.overwrite_project_area" : "map.save_project_area"}
          icon={BiSave}
          buttonType="button"
          handleClick={onSaveArea}
          isLoading={isSaveLoading}
        />
      </FadeAnimation>
    </div>
  );
};

export default MapButtons; 